import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { isPendingData, PendingData } from './pending-data.model'

@Injectable({
  providedIn: 'root',
})
export class ResolvePendingDataGuard {
  constructor(private readonly router: Router) {}

  public resolve(): Observable<PendingData | null> | Promise<PendingData | null> | PendingData | null {
    const { state } = this.router.getCurrentNavigation()?.extras || {}
    return isPendingData(state) ? state : null
  }
}
